import React, { Component } from 'react';
import { Box, Heading, Text, Button, VStack, Code } from '@chakra-ui/react';
import { reportReactError } from '../../tracing';

/**
 * Error Boundary para captura de errores React → SigNoz
 *
 * <ErrorBoundary>
 *   <MiComponente />
 * </ErrorBoundary>
 */
class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null, errorInfo: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		this.setState({ errorInfo });
		reportReactError(error, errorInfo);
	}

	handleReset = () => {
		this.setState({ hasError: false, error: null, errorInfo: null });
	};

	render() {
		const { hasError, error, errorInfo } = this.state;
		const { children, fallback } = this.props;

		if (hasError) {
			if (fallback) return fallback;

			return (
				<Box
					minH='50vh'
					display='flex'
					alignItems='center'
					justifyContent='center'
					p={8}
				>
					<VStack spacing={6} maxW='600px' textAlign='center'>
						<Heading size='lg' color='red.500'>
							Algo salió mal
						</Heading>
						<Text color='gray.600'>
							Ha ocurrido un error inesperado. Por favor, intenta
							recargar la página.
						</Text>
						{process.env.NODE_ENV === 'development' && error && (
							<Box
								w='100%'
								p={4}
								bg='gray.100'
								borderRadius='md'
								textAlign='left'
							>
								<Text fontWeight='bold' color='red.600' mb={2}>
									{error.name}: {error.message}
								</Text>
								{errorInfo && (
									<Code
										display='block'
										whiteSpace='pre-wrap'
										fontSize='xs'
										p={2}
										bg='gray.200'
									>
										{errorInfo.componentStack}
									</Code>
								)}
							</Box>
						)}
						<VStack spacing={3}>
							<Button
								colorScheme='blue'
								onClick={() => window.location.reload()}
							>
								Recargar página
							</Button>
							<Button
								variant='outline'
								onClick={this.handleReset}
							>
								Intentar de nuevo
							</Button>
						</VStack>
					</VStack>
				</Box>
			);
		}

		return children;
	}
}

export default ErrorBoundary;
